import { Box, HStack, Icon, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiQuestionnaireFill } from 'react-icons/ri';
import { VideoPreviewModal } from '../../../../app/components/VideoPreviewModal';
import { VideoTrigger } from '../../../../app/components/VideoTrigger';
import colors from '../../../../styles/colors';
import { QuestionOnReviewT, QuestionType } from './ReviewQuestion.types';

type VideoItem = { id: string; url: string; label: string };

export const ReviewVideoQuestion = React.memo(function ReviewVideoQuestion({ question }: { question: QuestionOnReviewT }) {
  const { t } = useTranslation();

  if (question.type !== QuestionType.VIDEO_RESPONSE) return null;

  const videoSrc = question.answer_hls ? question.answer_hls : question.answer || '';

  const hasVideo = Boolean(videoSrc);
  // Build a typed video item so the modal's getVideo* callbacks are type-safe
  const videoItem: VideoItem = {
    id: question.id,
    url: videoSrc as string,
    label: question.text ?? /* istanbul ignore next  */ '',
  };

  return (
    <Box>
      {hasVideo && (
        <Box width="100%">
          <VideoPreviewModal<VideoItem>
            video={videoItem}
            getVideoKey={(v) => v?.id ?? ''}
            getVideoSrc={(v) => v?.url ?? ''}
            getVideoAlt={(v) => v?.label ?? ''}
            setTrigger={<VideoTrigger src={videoSrc as string} />}
          />
        </Box>
      )}

      {!hasVideo && (
        <HStack spacing={2} mt={1}>
          <Icon as={RiQuestionnaireFill} color="orange.400" />
          <Text fontSize="sm" fontWeight="bold" color={colors.text.dark}>
            {t('videoResponseQuestions.skipped')}
          </Text>
        </HStack>
      )}
    </Box>
  );
});
